<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="row mt-1">
  <div class="col-lg-4 offset-lg-4">
    <div class="card text-white bg-secondary mb-3" style="max-width: 25rem;">
      <div class="card-header text-center">{{ operacion }} Student</div>
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="addStudent()">
          <input formControlName="name" type="text" class="form-control" placeholder="Ingrese nombre">
          <span *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched">
            El campo nombre es <strong>requerido</strong>
          </span>

          <input formControlName="lastname" type="text" class="form-control mt-2" placeholder="Ingrese apellidos">
          <span *ngIf="form.get('lastname')?.hasError('required') && form.get('lastname')?.touched">
            El campo apellidos es <strong>requerido</strong>
          </span>

          <input formControlName="ci" type="text" class="form-control mt-2" placeholder="Ingrese documento de identificación">
          <span *ngIf="form.get('ci')?.hasError('required') && form.get('ci')?.touched">
            El campo CI es <strong>requerido</strong>
          </span>

          <input formControlName="email" type="email" class="form-control mt-2" placeholder="Ingrese email">
          <span *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched">
            El campo email es <strong>requerido</strong>
          </span>
          <span *ngIf="form.get('email')?.hasError('email') && form.get('email')?.touched">
            El email debe ser válido
          </span>

          <select formControlName="idcareer" class="form-select mt-2">
            <option value="">Seleccione una carrera</option>
            <option *ngFor="let career of careers" [value]="career.id">{{ career.name }}</option>
          </select>
          <span *ngIf="form.get('idcareer')?.hasError('required') && form.get('idcareer')?.touched">
            La carrera es <strong>requerida</strong>
          </span>

          <div class="row mt-2 text-center">
            <div class="col-lg-6">
              <button routerLink="/student" type="button" class="btn btn-secondary">Volver</button>
            </div>
            <div class="col-lg-6">
              <button [disabled]="form.invalid" type="submit" class="btn btn-primary">Aceptar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
